/**
 * Shared visual treatment for add-ons added to an order after booking, used by the Job
 * Summary `New Add-ons` group and by the `New Add-ons / Products` group in the pricing
 * section's Additional Fees list.
 *
 * The approved mockup rendered these in blue, but blue is reserved for informational
 * badges in the admin system. We instead reuse the existing amber "warning" attention
 * token already defined in apps/admin-web/tailwind.config.js (`icon-warning`) and used by
 * the restricted-order banner in OrderDetails, so post-booking additions read as "needs
 * attention" without introducing a new color. Meaning is always carried by the group label
 * and item metadata as well, never by color alone.
 */
export const ADDED_AFTER_BOOKING_TEXT = 'text-icon-warning';
